import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import lotService from "../../services/lot-service";
import { Divider, Spin } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import { Fab } from "@mui/material";
import Swal from "sweetalert2";

const AdminLots = () => {

  const actual_date = moment(new Date()).format('yyyy');

  let navigate = useNavigate();
  const [farmName, setFarmName] = useState("");
  const [listLots, setListLots] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(false);
  const [sessionUser, setSessionUser] = useState("admin");


  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  const optionsState = [
    { id: true, name: "ACTIVO" },
    { id: false, name: "INACTIVO" },
  ];

  const goToUploadExcel = (lot) => {
    localStorage.setItem("lotId", lot._id);
    localStorage.setItem("lotName", lot.name);
    localStorage.setItem("density", lot.density);
    navigate("/menu-lines");
  };




  const goToLotMap = (lot) => {
    localStorage.setItem("lotId", lot._id);
    localStorage.setItem("lotName", lot.name);
    localStorage.setItem("density", lot.density);
    //navigate(`/lot-map/${lot._id}`);
    const url = `/lot-map/${lot._id}`;
    window.open(url, '_blank');
  };


  const goToLotMapEdition = (lot) => {
    localStorage.setItem("lotId", lot._id);
    localStorage.setItem("lotName", lot.name);
    localStorage.setItem("density", lot.density);
    //navigate(`/lot-map-edition/${lot._id}`);    
    const url = `/lot-map-edition/${lot._id}`;
    window.open(url, '_blank');
  };


  const goToMenuLines = (lot) => {
    localStorage.setItem("lotId", lot._id);
    localStorage.setItem("lotName", lot.name);
    localStorage.setItem("density", lot.density);
    navigate("/admin-lines");
  };







  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE
  const getListBySection = async () => {
    setLoading(true)
    const sectionId = localStorage.getItem("sectionId");
    const listado = await lotService.getListBySection(sectionId);
    if (listado) {
      setListLots(listado);
    }
    setLoading(false)
  };

  const customSubmit = async (data) => {
    console.log(data.hectares)
    if (!data.hectares) data.hectares = 0;
    setLoading(true)
    const response = await lotService.insert(data);


    if (response.data.success) {
      setValue("name", "");
      setValue("hectares", "");
      setValue("lotCode", "");
      setValue("tileset", "");
      setValue("coordinates", "");
      setValue("state", true);
      await getListBySection();
      toast('Realizado.', { autoClose: 1000 });
    }
    else {

      toast.error(response.data.message, { autoClose: 2100 })


    }




    setLoading(false)
  };

  const getLot = async (lotId) => {
    const lot = await lotService.getLot(lotId);
    if (lot) {
      setValue("id", lot._id);
      setValue("farmId", lot.farmId);
      setValue("farmName", lot.farmName);
      setValue("sectionId", lot.sectionId);
      setValue("sectionName", lot.sectionName);
      setValue("name", lot.name);
      setValue("hectares", lot.hectares);
      setValue("year", lot.year);
      setValue("tileset", lot.tileset);
      setValue("density", lot.density);
      setValue("state", lot.state);
      setValue("lotCode", lot.lotCode);
      setShowEdit(true);
      setShowSave(false);


      setValue("coordinates", "");
      if (lot.lotPolygon?.coordinates) {
        setValue(
          "coordinates",
          JSON.stringify(lot.lotPolygon.coordinates, null, 2)
        );
      }

    }
  };

  const updateLot = async () => {
    setLoading(true)
    const id = getValues("id");
    const name = getValues("name");
    let hectares = getValues("hectares");
    const year = getValues("year");
    const tileset = getValues("tileset");
    const density = getValues("density");
    const state = getValues("state");
    const lotCode = getValues("lotCode");
    const coordinates = getValues("coordinates");


    console.log("hectares:::", hectares)
    if (!hectares) hectares = 0;

    console.log("hectares rrr:::", hectares)
    const data = { id, name, state, hectares, density, year, lotCode, tileset, coordinates };
    const success = await lotService.update(data);
    if (success) {
      getListBySection();
      cancelar();
      toast('Realizado.', { autoClose: 1000 });
    }
    setLoading(false)
  };

  const cancelar = async () => {
    setShowEdit(false);
    setShowSave(true);
    setValue("name", "");
    setValue("hectares", "");
    setValue("lotCode", "");
    setValue("tileset", "");
    setValue("coordinates", "");
    setValue("state", true);
  };


  const capitalizeWords = (e) => {
    let value = e.target.value;
    value = value
      .split(' ') // Divide el texto en palabras
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitaliza la primera letra de cada palabra
      )
      .join(' ');
    setValue("name", value);
  };



  const nameToUpper = (e) => {
    let value = e.target.value.toUpperCase();
    setValue("name", value);
    console.log(showSave)
    if (showSave) {
      const valueWithOutSpace = value.replace(/\s+/g, '');
      setValue("lotCode", valueWithOutSpace);
    }
  };



  const lotCodeToUpper = (e) => {
    let value = e.target.value.toUpperCase();
    setValue("lotCode", value);
  };





  const deleteLot = async (id, name) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar  lote`,
        html: `Desea eliminar ${name}, sus lineas y palmas? <br/> <em>(Solo puede eliminar lotes sin tareas asociadas)</em> `,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const data = { id };
          const response = await lotService.deleteLot(data);
          console.log(response)
          if (response.success) {
            getListBySection();
            toast(response.message, { autoClose: 1000 });
          }
          else {
            toast.error(response.error, { autoClose: 1000 });
          }
          setLoading(false)
        }
      });
    }
  }





  useEffect(() => {
    const farm_id = localStorage.getItem("farmId");
    const farm_name = localStorage.getItem("farmName");

    const section_id = localStorage.getItem("sectionId");
    const section_name = localStorage.getItem("sectionName");

    const username = localStorage.getItem("username");
    setSessionUser(username)


    setTitle(farm_name + " - " + section_name)
    setFarmName(farm_name);
    setValue("farmId", farm_id);
    setValue("farmName", farm_name);
    setValue("sectionId", section_id);
    setValue("sectionName", section_name);
    getListBySection();
  }, []);



  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider
          orientation="left"
          style={{
            borderColor: "#AAAAAA"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            <span>FINCA: {title}</span>

            <Link
              to="/admin-section"
              className="nav-link link-primary p-1"
            >
              <i className="bi bi-arrow-left-short fa-lg"></i>

              <span className="fs-6 m-1">
                <strong>
                  REGRESAR A SECCIONES
                </strong>
              </span>
            </Link>
          </div>
        </Divider>
      </div>





      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
            <div className="row">
              <div className="card-title">
              </div>

              <div className=" col-12 d-none">
                <label>Id lote</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("id")}
                />
              </div>

              <div className=" col-12 d-none">
                <label>Id Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmId")}
                />
              </div>

              <div className=" col-12">
                <label>Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmName")}
                />
              </div>



              <div className=" col-12 d-none">
                <label>Id Secion</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("sectionId")}
                />
              </div>

              <div className=" col-12">
                <label>Seccion</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("sectionName")}
                />
              </div>



              <div className=" col-12">
                <label>Nombre del lote</label>
                <input
                  type="text"
                  onKeyUp={nameToUpper}
                  className="form-control"
                  {...register("name", { required: true, minLength: 3 })}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.name?.type === "minLength" && (
                  <small className="text-danger">Minimo 3 caracteres</small>
                )}
              </div>



              <div className=" col-6">
                <label>Codigo de lote</label>
                <input
                  type="text"
                  onKeyUp={lotCodeToUpper}
                  className="form-control"
                  {...register("lotCode")}
                />
              </div>


              <div className=" col-6">
                <label>Palmas / ha</label>
                <input
                  type="number"
                  className="form-control"
                  {...register("density")}
                />
              </div>


              <div className=" col-6">
                <label>Hectáreas</label>
                <input
                  readOnly={true}
                  type="number"
                  step="any"
                  className="form-control bg-light"
                  {...register("hectares")}
                />
              </div>



              <div className=" col-6">
                <label>Año siembra</label>
                <input
                  type="number"
                  className="form-control"
                  {...register("year")}
                />
              </div>



              <div className=" col-6">
                <label>Tileset</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("tileset")}
                />
              </div>



              <div className=" col-6">
                <label>Estado</label>
                <select className="form-control" {...register("state")}>
                  {optionsState.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className={sessionUser == "superadmin" ? "col-12" : "d-none"}>
                <label>Coordenadas del poligono</label>
                <textarea style={{ height: '50px' }}
                  className="form-control" {...register("coordinates")}
                >
                </textarea>
              </div>

              <div className={showEdit ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => updateLot()}
                  >
                    <i className="bi bi-save fa-lg m-2" /> Editar
                  </button>
                </Spin>
              </div>

              <div className={showSave ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button className="btn btn-primary w-100" type="submit">
                    <i className="bi bi-save fa-lg m-2" /> Guardar
                  </button>
                </Spin>
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button
                    className="btn btn-secondary w-100"
                    type="button"
                    onClick={() => cancelar()}
                  >
                    <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                  </button>
                </Spin>
              </div>
            </div>
          </form>
        </div>

      </div>


      <div className="col-12 col-sm-8">

        <div className="card p-4">
          <div className="card-title" style={{minHeight:'350px'}}>
            <h3 className="text-secondary mx-3" >Listado de lotes</h3>
            <hr></hr>
            <div className="tbl-container bdr">
              <Spin spinning={loading}>
                <table className="table ">
                  <thead className="table-primary">
                    <tr>
                      <th >Nombre</th>
                      <th>Código</th>
                      <th>Edad</th>
                      <th>Ha</th>
                      <th>Pal/ha</th>
                      <th>Palmas</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listLots.map((lot) => (
                      <tr key={lot._id} className={lot.state ? "" : "table-secondary"}  >
                        <td className="small" >{lot.name}</td>
                        <td>{lot.lotCode}</td>
                        <td>{actual_date - lot.year}</td>
                        <td>{lot.hectares ? lot.hectares.toFixed(2) : lot.hectares}</td>
                        <td>{lot.density}</td>
                        <td>{lot.palmsPlanted}</td>
                        <td className="text-center" style={{ width: "65px" }}>

                          <div className="dropdown">

                            <button
                              className="btn btn-light border"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              title="Acciones del lote"
                            >
                              <i className="bi bi-three-dots-vertical"></i>
                            </button>

                            <ul className="dropdown-menu dropdown-menu-end shadow-sm">

                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => getLot(lot._id)}
                                >
                                  <i className="bi bi-pencil me-2 text-primary"></i>
                                  Editar lote
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => goToUploadExcel(lot)}
                                >
                                  <i className="bi bi-file-earmark-excel me-2 text-success"></i>
                                  Subir Excel
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => goToMenuLines(lot)}
                                >
                                  <i className="bi bi-list-ul me-2"></i>
                                  Administrar líneas
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={() => goToLotMap(lot)}
                                >
                                  <i className={`bi bi-map me-2 ${lot.tileset ? "text-success" : "text-secondary"}`}></i>
                                  Ver mapa
                                </button>
                              </li>

                              {sessionUser === "superadmin" && (
                                <>
                                  <li><hr className="dropdown-divider" /></li>

                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => goToLotMapEdition(lot)}
                                    >
                                      <i className="bi bi-geo-alt me-2 text-info"></i>
                                      Editar geografía
                                    </button>
                                  </li>

                                  <li>
                                    <button
                                      className="dropdown-item text-danger"
                                      onClick={() => deleteLot(lot._id, lot.name)}
                                    >
                                      <i className="bi bi-trash me-2"></i>
                                      Eliminar lote
                                    </button>
                                  </li>
                                </>
                              )}

                            </ul>

                          </div>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>
      </div>



    </div>
  );
};

export default AdminLots;
